module.exports = "<mat-paginator\n  [length]=\"totalNumberOfRecords\"\n  [pageSize]=\"10\"\n  [pageSizeOptions]=\"[5, 10, 25, 50, 100]\"\n  (page)=\"onPageSizeOrPageIndexChange($event)\"\n>\n</mat-paginator>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/paginator/paginator.component.html
// module id = ../../../../../src/app/components/admin/components/shared/paginator/paginator.component.html
// module chunks = main